module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTkyMy4xIDQ0OGEzMiAzMiAwIDAgMSAzMS43IDM2LjVsLTU0LjggMzg0YTMyIDMyIDAgMCAxLTMxLjcgMjcuNUgxNTUuN2EzMiAzMiAwIDAgMS0zMS43LTI3LjVsLTU0LjgtMzg0QTMyIDMyIDAgMCAxIDEwMC45IDQ0OGg4MjIuMnpNMzY0LjIgMTI4YTMyIDMyIDAgMCAxIDI4LjYgMTcuN0w0NDggMjU2aDQxNmEzMiAzMiAwIDAgMSAzMiAzMnY5NkgxMjhWMTYwYTMyIDMyIDAgMCAxIDMyLTMyaDIwNC4yeiIgZmlsbD0iIzAiIHAtaWQ9IjQ5MjEiPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Open folder-filled.svg
// module id = 0f+i
// module chunks = 75